export default {
  computed: {
    headerFontSize () {
      if (this.$vuetify.breakpoint.lgAndDown) return "text-h6";
      else return "text-h5";
    },
    subheaderFontSize () {
      if (this.$vuetify.breakpoint.lgAndDown) return "text-subtitle-1";
      else return "text-h6";
    },
    smallFontSize () {
      if (this.$vuetify.breakpoint.lgAndDown) return "text-subtitle-2";
      else return "text-subtitle-1";
    },
    displayFontSize () {
      if (this.$vuetify.breakpoint.lgAndDown) return "text-h6";
      else return "text-h5";
    },
    veryBigFontSize () {
      if (this.$vuetify.breakpoint.smAndDown) return "text-h5";
      else if (this.$vuetify.breakpoint.lgAndDown) return "text-h4";
      else return "text-h3";
    },
    bannerHeight () {
      return 70;
    },
    isMobileView () {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isTabletView () {
      return this.$vuetify.breakpoint.md;
    },
    isWebView () {
      return !this.isMobileView && !this.isTabletView;
    }
  },
  methods: {
    goBack: function () {
      this.$router.back();
    },
    login: function () {
      this.$store.dispatch("auth/login");
    },
    routeTitle (breadcrumbs) {
      var title =
        this.$route.matched &&
          this.$route.matched.length > 0 &&
          this.$route.matched[this.$route.matched.length - 1] &&
          this.$route.matched[this.$route.matched.length - 1].meta
          ? breadcrumbs &&
            this.$route.matched[this.$route.matched.length - 1].meta
              .breadcrumbsTitle
            ? this.$route.matched[this.$route.matched.length - 1].meta
              .breadcrumbsTitle
            : this.$route.matched[this.$route.matched.length - 1].meta.title
          : name;
      return title;
    }
  }
};
